import React from 'react';
import { Slot } from '@radix-ui/react-slot';

import { cn } from '@epoch-ui/lib/utils';

interface ButtonLinkProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  asChild?: boolean;
}

/**
 * ButtonLink is a button that looks like a link.
 */

const ButtonLink = React.forwardRef<HTMLButtonElement, ButtonLinkProps>(
  ({ className, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';
    return (
      <Comp
        {...(!asChild && { type: 'button' })} // prevent default form submission
        className={cn(
          'tw-m-0 tw-p-0',
          'tw-text-sm tw-font-medium tw-leading-4 tw-text-primary-blue',
          'hover:tw-text-primary-blue hover:tw-underline',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

export { ButtonLink };
